import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar';
import WorkHero from './WorkHero';
import WorkNavigation from './WorkNavigation';
import { loadWorkData, getWorkNavigation } from '../../utils/workUtils';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Generic template to render markdown-backed detail pages.
// Accepts optional loader and navigation functions to support different collections.
const WorkPageTemplate = ({ workId, id, loadDataFn, getNavigationFn }) => {
  const [data, setData] = useState(null);
  const [navigation, setNavigation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadAll = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const effectiveId = id || workId;
        const loader = loadDataFn || loadWorkData;
        const navigatorFn = getNavigationFn || getWorkNavigation;
        const workData = await loader(effectiveId);
        const navData = await navigatorFn(effectiveId);
        
        if (!workData) {
          setError('Work item not found');
        } else {
          setData(workData);
          setNavigation(navData);
        }
      } catch (err) {
        setError('Error loading work data');
      } finally {
        setLoading(false);
      }
    };

    const effectiveId = id || workId;
    if (effectiveId) {
      loadAll();
    }
  }, [workId, id, loadDataFn, getNavigationFn]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-24 px-4">
          <div className="max-w-4xl mx-auto">
            <div className="flex justify-center items-center min-h-64">
              <span className="loading loading-spinner loading-lg"></span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-24 px-4">
          <div className="max-w-4xl mx-auto">
            <p className="text-center text-lg">{error || 'Work item not found'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-24">
        {/* Hero section - no background change */}
        <div className="px-4">
          <div className="max-w-4xl mx-auto">
            {/* <div className="mb-8">
              <Link to="/work" className="text-orange-500 hover:text-orange-600 mb-4 inline-block">
                ← Back to Work & Case Studies
              </Link>
            </div> */}
            
            <WorkHero 
              title={data.title}
              subtitle={data.subtitle}
              badges={data.badges}
              skills={data.skills}
              overview={data.overview}
              image={data.heroImage}
              alt={data.title}
            />
          </div>
        </div>
        
        {/* Markdown body */}
        <div className="bg-white w-full py-12">
          <div className="max-w-4xl mx-auto px-4">
            <div className="prose max-w-none">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {data.body || ''}
              </ReactMarkdown>
            </div>
          </div>
        </div>
        
        {/* Navigation - white background */}
        {navigation && (
          <div className="bg-white w-full py-12">
            <div className="max-w-5xl mx-auto px-4">
              <WorkNavigation navigation={navigation} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkPageTemplate; 